import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { adminCommunicationSettings } from "../../../schemas";
import { useFormik } from "formik";
import CreatableSelect from "react-select/creatable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_ADMIN_SETTINGS, UPDATE_ADMIN_SETTINGS } from "../../../env";
import {
    postRecords,
    getRecords,
    catchAsync,
    isSuccess,
    toastSuccessMessages,
    toastErrorMessages,
} from "../../../helper/helper";
import ProgressComponent from "../../../components/general/ProgressComponent";
import Input from "../../../components/forms-fields/Input";
import moment from "moment";

function CommunicationGroupSettings({ subModalCommunicationSettings }) {
    const handleShowHideModal = () => {
        subModalCommunicationSettings((prevShow) => !prevShow);
    };
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
    const [isToastAdminSettings, setIsToastAdminSettings] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [communicationSettingDefault, setCommunicationSettingDefault] = useState("");
    const [durationHours, setDurationHours] = useState(0);
    const [durationMinutes, setDurationMinutes] = useState(0);
    const getAPIquery = {};

    const [suFormData, setSuFormData] = useState({
        communicationSetting: {
            startTime: moment(communicationSettingDefault.startTime).format("HH:mm"),
            endTime: moment(communicationSettingDefault.endTime).format("HH:mm"),
        }
    });



    const {
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        handleChange,
        handleBlur,
    } = useFormik({
        initialValues: suFormData,
        validationSchema: adminCommunicationSettings,
        onSubmit: async (values) => {
            try {
                setIsSubmitButtonClicked(true);
                await postAdminSettingsFormData(values);
            } catch (error) {

            }
        },
    });

    const processPostRecords = (method, data) => {

        if (data?.status !== isSuccess) {
            setIsToastAdminSettings(true);
            toastErrorMessages(toast.error, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            handleShowHideModal();
        } else if (
            method === "postAdminSettingsFormData" &&
            data?.status === isSuccess
        ) {
            setIsToastAdminSettings(true);
            toastSuccessMessages(toast.success, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            setTimeout(() => {
                handleShowHideModal();
            }, 2000);
        } else if (method === "get" && data?.status === isSuccess) {
            const result = data?.data;
            // console.log("🚀 ~ processPostRecords ~ result:", result)
            setCommunicationSettingDefault(result?.communicationSetting);
            setIsLoading(false);
        }
    };

    const postAdminSettingsFormData = catchAsync(async (req, res) => {
        const updateValues = {
            ...values,
            communicationSetting: {
                startTime: moment(values?.communicationSetting?.startTime, 'HH:mm').valueOf(),
                endTime: moment(values?.communicationSetting?.endTime, 'HH:mm').valueOf()
            }
        };
        // console.log("🚀 ~ postAdminSettingsFormData ~ values:", values)
        // console.log("🚀 ~ postAdminSettingsFormData ~ updateValues:", updateValues)
        const response = await postRecords(UPDATE_ADMIN_SETTINGS, updateValues);
        // console.log("🚀 ~ postAdminSettingsFormData ~ response:", response)
        setIsSubmitButtonClicked(false);
        processPostRecords("postAdminSettingsFormData", response);
    });


    const fetchAllRecords = catchAsync(async (req, res) => {
        setIsLoading(true)
        const response = await getRecords(GET_ADMIN_SETTINGS, getAPIquery);
        // console.log("🚀 ~ fetchAllRecords ~ response:", response)
        processPostRecords("get", response);
        setIsLoading(false)
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    useEffect(() => {
        if (communicationSettingDefault?.startTime && communicationSettingDefault?.endTime) {
            setFieldValue("communicationSetting.startTime", moment(communicationSettingDefault.startTime).format("HH:mm"));
            setFieldValue("communicationSetting.endTime", moment(communicationSettingDefault.endTime).format("HH:mm"));
        }
        // console.log("Updated communicationSettingDefault:", communicationSettingDefault);
    }, [communicationSettingDefault, setFieldValue]);

    //Showing Time duration
    useEffect(() => {
        const startTime = moment(values?.communicationSetting?.startTime, 'HH:mm').toDate();
        const endTime = moment(values?.communicationSetting?.endTime, 'HH:mm').toDate();

        if ((startTime !== NaN) && (endTime !== NaN)) {
            const durationInMilliseconds = endTime - startTime;

            const hours = Math.floor(durationInMilliseconds / (1000 * 60 * 60));
            const minutes = Math.floor((durationInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
            //   const durationInMinutes = durationInMilliseconds / (1000 * 60);
            //   setAptMinutes(durationInMinutes);
            setDurationHours(hours);
            setDurationMinutes(minutes);
        }
        else {
            setDurationHours(0);
            setDurationMinutes(0);
            //   setAptMinutes(0);
        }
    }, [values?.communicationSetting?.startTime, values?.communicationSetting?.endTime]);


    return (
        <>
            <div className="incidents consentCapacityAddNew">
                {isLoading ? (
                    <div className="minHeight250">
                        <ProgressComponent />
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="formBlockContent" style={{ minHeight: "180px" }}>
                            <div className="row">

                                <div className="col-md-12 mb-3">
                                    <Input
                                        type="time"
                                        id="communicationSetting.startTime"
                                        name="communicationSetting.startTime"
                                        value={values?.communicationSetting?.startTime}
                                        onChange={(e) => setFieldValue("communicationSetting.startTime", e.target.value)}
                                        onBlur={handleBlur}
                                        labelText="Start Time"
                                        marginBottom={true}
                                        customError={touched?.communicationSetting?.startTime && errors?.communicationSetting?.startTime}
                                        errorMessage={errors?.communicationSetting?.startTime}
                                        erroClass={
                                            touched?.communicationSetting?.startTime && errors?.communicationSetting?.startTime
                                                ? "validationError"
                                                : ""
                                        }
                                    />
                                </div>
                                <div className="col-md-12">
                                    <Input
                                        type="time"
                                        id="communicationSetting.endTime"
                                        name="communicationSetting.endTime"
                                        value={values?.communicationSetting?.endTime}
                                        onChange={(e) => setFieldValue("communicationSetting.endTime", e.target.value)}
                                        onBlur={handleBlur}
                                        labelText="End Time"
                                        marginBottom={true}
                                        customError={touched?.communicationSetting?.endTime && errors?.communicationSetting?.endTime}
                                        errorMessage={errors?.communicationSetting?.endTime}
                                        erroClass={
                                            touched?.communicationSetting?.endTime && errors?.communicationSetting?.endTime
                                                ? "validationError"
                                                : ""
                                        }
                                    />
                                </div>
                                <div className="col-md-12">
                                    <p>
                                        <strong><small>Default communcation duration {durationHours ? durationHours : 0} hours and {durationMinutes ? durationMinutes : 0} minutes</small></strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="formActionButtons">
                            {isSubmitButtonClicked ? (
                                <Button
                                    onClick={subModalCommunicationSettings}
                                    className="btn-sm"
                                    variant="primary"
                                    disabled
                                >
                                    Loading...
                                </Button>
                            ) : (
                                <Button className="btn-sm" variant="primary" type="submit">
                                    Submit
                                </Button>
                            )}
                            <span
                                onClick={subModalCommunicationSettings}
                                className="btn btn-sm btn-outline-primary"
                            >
                                Close
                            </span>

                        </div>
                    </form>
                )}
            </div>
            {isToastAdminSettings ? <ToastContainer /> : ''}

        </>
    );
}

export default CommunicationGroupSettings;